import React from 'react';

import { BVShimmer } from '../../../models/BVShimmers/BVShimmer';

import './bv-shimmer-price.scss';

interface IBVShimmerPrice extends BVShimmer { }

const BVShimmerPrice: React.FunctionComponent<IBVShimmerPrice> = ({ style }) => (
    <div className="bv-shimmer-price" style={style}>
        <div className="shimmer-wrapper">
            <div className="shimmer-price shimmer-price-retail">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-price">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
        </div>
    </div>
);

export default BVShimmerPrice;